import React, {Component} from 'react';
import { Layout, Form, Input, Button } from 'antd';

import s from './Login.module.scss';
import FirebaseContext, {withFirebase} from "../../context/firebaseContext";

const { Content } = Layout;

class LoginPage extends Component {
    onFinish = ({email, password}) => {
        const {signWithEmail, setUserUid} = this.props.firebase;
        const { history } = this.props;
        signWithEmail(email, password)
            .then(res => {
                setUserUid(res.user.uid);
                localStorage.setItem('user', res.user.uid);
                history.push('/home');
            });
    };

    onFinishFailed = (errorMsg) => {
        console.log('####: errorMsg', errorMsg);
    };

    renderForm = () => {
        const layout = {
            labelCol: {
                span: 6,
            },
            wrapperCol: {
                span: 18,
            },
        };
        const tailLayout = {
            wrapperCol: {
                offset: 6,
                span: 18,
            },
        };

        return (
            <Form
                {...layout}
                name="basic"
                initialValues={{ remember: true }}
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
            >
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, message: 'Please input your email!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        )
    };

    render() {

        return (
            <Layout>
                <Content>
                    <div className={s.root}>
                        <div className={s.form_wrap}>
                            {this.renderForm()}
                        </div>
                    </div>
                </Content>
            </Layout>
        );
    }
}

LoginPage.contextType = FirebaseContext;

export default withFirebase(LoginPage);